module.exports = __webpack_public_path__ + "img/rectangles-mixed.83ae305e.svg";